import React, { useId } from "react";

import Particles, {
  ParticlesProvider,
} from "@tsparticles/react";

import { loadSlim } from "@tsparticles/slim";

import {
  motion,
  useAnimation,
} from "framer-motion";

import { cn } from "../../lib/utils";


export const SparklesCore = ({
  id,
  className,
  background = "transparent",
  minSize = 0.4,
  maxSize = 1.4,
  speed = 1,
  particleColor = "#D4AF37",
  particleDensity = 500,
}) => {

  const controls = useAnimation();

  const generatedId = useId();


  const particlesLoaded = async (container) => {

    if (!container) return;

    controls.start({
      opacity: 1,

      transition: {
        duration: 1,
      },
    });

  };


  return (

    <motion.div
      animate={controls}
      initial={{
        opacity: 0,
      }}
      className={cn(
        "h-full w-full",
        className
      )}
    >

      <ParticlesProvider init={loadSlim}>
        <Particles
          id={id || generatedId}
          particlesLoaded={particlesLoaded}
          className="h-full w-full"
          options={{
            background: {
              color: {
                value: background,
              },
            },
            fullScreen: {
              enable: false,
              zIndex: 0,
            },


            fpsLimit: 60,


            interactivity: {

              events: {

                onClick: {
                  enable: false,
                },

                onHover: {
                  enable: false,
                },

                resize: true,

              },

            },


            particles: {

              color: {
                value: particleColor,
              },


              move: {

                enable: true,

                direction: "none",

                random: true,

                straight: false,

                speed: {
                  min: 0.1,
                  max: speed,
                },

                outModes: {
                  default: "out",
                },

              },


              number: {

                density: {
                  enable: true,
                  width: 400,
                  height: 400,
                },

                value: particleDensity,

              },


              opacity: {

                value: {
                  min: 0.1,
                  max: 1,
                },

                animation: {

                  enable: true,

                  speed: 1,

                  sync: false,

                  startValue: "random",

                },

              },


              shape: {
                type: "circle",
              },


              size: {

                value: {
                  min: minSize,
                  max: maxSize,
                },

              },

            },


            detectRetina: true,

          }}
        />
      </ParticlesProvider>

    </motion.div>

  );

};